import {useCallback, useState} from 'react';

export function useToggle<ValueType>(defaultOpen = false) {
  const [open, setOpen] = useState(defaultOpen);
  const [value, setValue] = useState<{target: ValueType | undefined}>({
    target: undefined,
  });

  const show = useCallback((value?: ValueType) => {
    setOpen(true);
    setValue({
      target: value,
    });
  }, []);

  const hide = useCallback(() => {
    setOpen(false);
    setValue({
      target: undefined,
    });
  }, []);

  return {open, show, hide, value: value.target};
}
